import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  question: Yup.string().nullable().required('field.error.required'),
  answer: Yup.string().nullable().required('field.error.required'),
})
